module.exports = __webpack_public_path__ + "static/media/poweredby_logo.1f3b3967.svg";